import * as React from 'react'
import styled from 'styled-components'
import { theme, progressiveBreakpoints } from '../../constants/theme'
import RightArrowImage from '../../static/images/arrowRight.svg'
import FlyingSimSmallImage from '../../static/images/flyingSimSmall.svg'
import InviteFriendsImage from '../../static/images/inviteFriends.svg'
import FreeMonthsImage from '../../static/images/freeMonths.svg'

const Wrapper = styled.div`
  padding-top: 18px;
`

const Title = styled.h2`
  font-size: 36px;
  line-height: 36px;
  margin: 30px 0;
`

const Steps = styled.div`
  display: flex;
  flex-direction: column;

  @media ${progressiveBreakpoints.desktopSmall} {
    flex-direction: row;
  }
`

const Step = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 295px;
  align-self: center;
  overflow: hidden;

  h3 {
    font-size: 0.7em;
    line-height: 1.5;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: ${theme.colors.fonts.green};
  }

  p {
    padding: 0 2em;
    font-size: 0.9em;
    line-height: 1.3em;
  }
`

const ArrowWrapper = styled.div`
  display: none;

  @media ${progressiveBreakpoints.desktopSmall} {
    display: block;
    align-self: center;
  }
`

const ArrowImage = styled.img`
  width: 25px;
  height: 25px;
`

const StepImage = styled.img`
  height: 100px;
  max-width: 120px;
  width: 100%;
  align-self: center;
`

const Arrow = () => (
  <ArrowWrapper>
    <ArrowImage src={RightArrowImage} alt="" />
  </ArrowWrapper>
)

const FreeMonthsHowTo = () => (
  <Wrapper>
    <Title>How to get your free months:</Title>
    <Steps>
      <Step>
        <StepImage src={FlyingSimSmallImage} alt="" />
        <h3>Order your SIM</h3>
        <p>
          Pick a plan below, order your SIM, and activate it when it arrives.
        </p>
      </Step>
      <Arrow />
      <Step>
        <StepImage src={InviteFriendsImage} alt="" />
        <h3>Invite friends</h3>
        <p>
          As soon as your SIM arrives you can invite as many friends as you like
          using your unique sharing link.
        </p>
      </Step>
      <Arrow />
      <Step>
        <StepImage src={FreeMonthsImage} alt="" />
        <h3>Get free months</h3>
        <p>
          For every friend that joins SMARTY using your sharing link you get a
          free month (they get one too).
        </p>
      </Step>
    </Steps>
  </Wrapper>
)

export default FreeMonthsHowTo
